import {makeTestData} from 'charts/BarChart/tests/makeData';
import update from 'charts/BarChart/update';
import StaticSvgDraw from 'components/StaticSvgDraw';
import React, {useState} from 'react';
import {makeReadConfigurator} from 'utils/makeConfigurator';

export default {
  Index() {
    const [reloadCount, setReloadCount] = useState(0);
    const data = makeTestData(makeReadConfigurator({}));
    const config = makeReadConfigurator({
      reload: () => {
        setReloadCount(reloadCount + 1);
        console.log('reload');
      },
    });
    return <StaticSvgDraw draw={svg => update(svg, data, config)} />;
  },
};
